import React from 'react';
import { useSelector } from 'react-redux';
import { GeckoAvatar, GeckoField, GECKO_CONSTS } from '../../ui';
import './index.scss';
import { myTeams, teamsSelector } from '../../selectors';

export const TeamOption = ({ name }) => (
  <div className="TeamSelect-TeamOption">
    <GeckoAvatar size={'sm'} name={name} />
    &nbsp;{name}
  </div>
);

export const TeamSelect = ({
  onChange,
  multi,
  ignore,
  selectProps,
  placeholder,
  value,
  restrictToUserTeams = false
}) => {
  const teamSelector = restrictToUserTeams ? myTeams : teamsSelector
  const teams = useSelector(teamSelector);

  const renderOption = (option) => <TeamOption {...option.team} />;

  const handleChange = (_key, value) => {
    onChange(value);
  };

  const field = {
    key: 'value',
    type:
      multi === false
        ? GECKO_CONSTS.FIELD_TYPE_SELECT
        : GECKO_CONSTS.FIELD_TYPE_SELECT_MULTI,
    options: teams
      .filter((team) => !(ignore || []).includes(team.id))
      .map((team) => {
        return {
          team: team,
          label: team.name,
          value: team.id,
        };
      }),
    optionRenderer: renderOption.bind(this),
    valueRenderer: renderOption.bind(this),
    config: selectProps || {},
    placeholder: placeholder,
  };
  const values = { value };
  return (
    <div
      className="TeamSelect"
      onClick={(event) => {
        event.stopPropagation();
      }}
    >
      <GeckoField
        field={field}
        values={values}
        handler={handleChange.bind(this)}
      />
    </div>
  );
};

export default TeamSelect;
